import { FC, ReactElement, useState } from 'react'
import { Container, NewMobileStyleTable } from './styles'
import { DashboardhSmallButton } from 'bd-web-components'
import { truncateString } from '../../utils/string-modeling'


interface TableData {
  name: string
  courtesy_day: string
  courtesy_time: string
  email: string
  cpf: string
  voucher: string
}

const table_data: TableData[] = [
  {
    name: "",
    courtesy_day: "",
    courtesy_time: "",
    email: "",
    cpf: "",
    voucher: "",
  },
]

export interface CourtesyTableProp {
  data: TableData[]
}

export const CourtesyTable: FC<CourtesyTableProp> = ({
  data = table_data,
}): ReactElement => {
  const [copiedKey, setCopiedKey] = useState<string | null>(null)

  const handleCopyLink = (key: string, link: string) => {
    if (!link) return
    navigator.clipboard.writeText(link)
    setCopiedKey(key)
    setTimeout(() => {
      setCopiedKey(null)
    }, 2000)
  }

  async function navigatorShareData(url: string = '', msg: string = '') {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Bilheteria Digital',
          text: msg,
          url,
        })
      } catch (error: any) {
        if (error.name === 'AbortError') {
          console.log('O usuário cancelou o compartilhamento.')
          return
        }
        console.error('Erro ao compartilhar:', error)
      }
    } else {
      alert('Seu navegador não suporta a API de compartilhamento.')
    }
  }

  return (
    <Container>
      <NewMobileStyleTable>
        <thead>
          <tr>
            <th>Data</th>
            <th>Hora</th>
            <th>Nome</th>
            <th>Email</th>
            <th>CPF</th>
            <th>Voucher</th>
            <th>Compartilhar</th>
          </tr>
        </thead>
        <tbody>
          {data.map((_: any, rowIndex: number) => {
            const msg = "Olá, aqui está seu ingresso!"
            const date = data[rowIndex].courtesy_day
            const hour = data[rowIndex].courtesy_time
            const name = data[rowIndex].name
            const email = data[rowIndex].email
            const cpf = data[rowIndex].cpf
            const voucher = data[rowIndex].voucher

            const key = name + email + cpf + rowIndex
            return (
              <tr key={key}>
                <td
                  data-label="Data"
                  className="column-container"
                >
                  {date}
                </td>
                <td
                  data-label="Hora"
                  className="column-container"
                >
                  {hour}
                </td>
                <td
                  data-label="Nome"
                  className="column-container ticket"
                >
                  {truncateString(name, 20)}
                </td>
                <td
                  data-label="Email"
                  className="column-container"
                >
                  {truncateString(email, 20)}
                </td>
                <td
                  data-label="CPF"
                  className="column-container"
                  key={`td-public-${1}`}
                >
                  {cpf}
                </td>
                <td
                  data-label="Voucher"
                  className="column-container"
                >
                  <DashboardhSmallButton
                    variant={'outlined'}
                    width='100px'
                    onClick={() => handleCopyLink(key, voucher)}
                  >
                    {copiedKey === key ? 'Copiado!' : 'Voucher'}
                  </DashboardhSmallButton>
                </td>
                <td
                  data-label="Compartilhar"
                  className="column-container"
                >
                  <DashboardhSmallButton
                    width='100px'
                    onClick={() => navigatorShareData(voucher, msg)}>
                      Compartilhar
                  </DashboardhSmallButton>
                </td>
              </tr>
            )
          })}
        </tbody>
      </NewMobileStyleTable>
    </Container>
  )
}


export default CourtesyTable